import {
  PAYMENT_GATEWAY_REDIRECTED_STORAGE_KEY,
  PAYMENT_STATUS_OUTCOME_FAILURE,
  PAYMENT_STATUS_OUTCOME_INSPECTION,
  PAYMENT_STATUS_OUTCOME_PENDING,
  PAYMENT_STATUS_OUTCOME_QUERY_KEY,
  PAYMENT_STATUS_OUTCOME_REQUIREMENTS,
  PAYMENT_STATUS_OUTCOME_STORAGE_KEY,
  PAYMENT_STATUS_OUTCOME_SUCCESS,
  PAYMENT_STATUS_PATH,
} from '@/lib/payment/payment-status-constants';

export const TERMINAL_OUTCOMES = [
  PAYMENT_STATUS_OUTCOME_SUCCESS,
  PAYMENT_STATUS_OUTCOME_FAILURE,
  PAYMENT_STATUS_OUTCOME_PENDING,
  PAYMENT_STATUS_OUTCOME_INSPECTION,
  PAYMENT_STATUS_OUTCOME_REQUIREMENTS,
];

/**
 * Build a /payment-status route location for a terminal outcome.
 * @param {{ outcome: string, journeyId?: string|number, msg?: string }} opts
 * @returns {{ path: string, query: Record<string, string> }}
 */
export function buildPaymentStatusOutcomeRoute({ outcome, journeyId, msg } = {}) {
  const query = {
    [PAYMENT_STATUS_OUTCOME_QUERY_KEY]: TERMINAL_OUTCOMES.includes(outcome)
      ? outcome
      : PAYMENT_STATUS_OUTCOME_SUCCESS,
  };
  if (journeyId != null && journeyId !== '') {
    query.journeyId = String(journeyId);
  }
  if (msg != null && msg !== '') {
    query.msg = String(msg);
  }
  return { path: PAYMENT_STATUS_PATH, query };
}

/**
 * Persist outcome in session so refresh/back-forward skips payment polling.
 * @param {string} outcome
 */
export function persistPaymentStatusOutcome(outcome) {
  if (!TERMINAL_OUTCOMES.includes(outcome)) {
    return;
  }
  sessionStorage.setItem(PAYMENT_STATUS_OUTCOME_STORAGE_KEY, outcome);
}

/**
 * Navigate to payment-status with a terminal outcome (writes session + router.push).
 * @param {{ push: Function }} router
 * @param {{ outcome: string, journeyId?: string|number, msg?: string }} opts
 */
export function navigateToPaymentStatusOutcome(router, opts = {}) {
  const outcome = TERMINAL_OUTCOMES.includes(opts.outcome)
    ? opts.outcome
    : PAYMENT_STATUS_OUTCOME_SUCCESS;
  persistPaymentStatusOutcome(outcome);
  router.push(buildPaymentStatusOutcomeRoute({ ...opts, outcome }));
}

/**
 * Clear terminal outcome flags so a retry can re-poll / reopen gateway.
 */
export function clearPaymentStatusOutcome() {
  sessionStorage.removeItem(PAYMENT_STATUS_OUTCOME_STORAGE_KEY);
  sessionStorage.removeItem(PAYMENT_GATEWAY_REDIRECTED_STORAGE_KEY);
}
